package com.sddamico.draftmachine.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.sddamico.draftmachine.api.ApiException
import com.sddamico.draftmachine.ds.motion.Motion
import com.sddamico.draftmachine.ds.motion.ViewTransitions

const val UNREACHABLE_MESSAGE = "Couldn't reach the machine."

/**
 * Runs [fetch] once on first composition and exposes its lifecycle as a [LoadState]. An
 * [ApiException] surfaces its [ApiException.errorMessage]; any other throwable falls back to
 * [UNREACHABLE_MESSAGE]. The switch away from [LoadState.Loading] plays as [settleMotion].
 */
@Composable
fun <T> rememberApiResource(settleMotion: Motion? = Motion.Fade, fetch: suspend () -> T): LoadState<T> {
  var state: LoadState<T> by remember { mutableStateOf(LoadState.Loading) }
  LaunchedEffect(Unit) {
    val settled = try {
      LoadState.Ready(fetch())
    } catch (e: ApiException) {
      LoadState.Failed(e.errorMessage)
    } catch (e: Throwable) {
      LoadState.Failed(e.message ?: UNREACHABLE_MESSAGE)
    }
    ViewTransitions.run(settleMotion) { state = settled }
  }
  return state
}
